import * as React from "react";

import { EMPTY_RUNTIME_CONFIG, getRuntimeConfig, type RuntimeConfig } from "@/services/config";

/** 读取后端下发的运行时配置；读取期间 `loading` 为 true（未知配置时不提前渲染入口）。 */
export function useRuntimeConfig(): { config: RuntimeConfig; loading: boolean } {
  const [config, setConfig] = React.useState<RuntimeConfig>(EMPTY_RUNTIME_CONFIG);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    let cancelled = false;
    void getRuntimeConfig().then((next) => {
      if (cancelled) return;
      setConfig(next);
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return { config, loading };
}
